


















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Report } from '@/modules/report';
import { UserTypes } from '@/enums/userTypes';
import { ReadTypes } from '@/enums/readTypes';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { AttachmentFile } from '@/models/attachmentFile';
import { ElForm } from 'element-ui/types/form';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component
export default class ReportDetails extends AvaivaledVue {
  @Prop() private reportId: string;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  private sendDate: Date | null = null;
  private sendTime: Date | null = null;

  private formRule = {
    sendDate: [
      { validator: this.validateSendDate, trigger: 'blur' },
    ],
  };

  private validateSendDate(rule: any, value: string, callback: any) {
    if (!this.sendDate !== !this.sendTime) {
      callback(new Error('通知日時は日付と時刻を両方入力するか未指定にしてください'));
    } else {
      callback();
    }
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get report(): Report {
    return this.$store.state.report.selectedReport;
  }

  get lessonDate(): string {
    if (!this.report) {
      return '';
    } else {
      const moment = (this as any).$moment;
      if (!this.report.lessonStartDate) {
        return '';
      }
      let start: string;
      if (this.report.lessonStartDate.getHours() === 0 && this.report.lessonStartDate.getMinutes() === 0) {
        start = moment(this.report.lessonStartDate).format('YYYY/MM/DD');
      } else {
        start = moment(this.report.lessonStartDate).format('YYYY/MM/DD H:mm');
      }
      if (!this.report.lessonEndDate) {
        return start;
      } else {
        if (this.report.lessonEndDate.getHours() === 0 && this.report.lessonEndDate.getMinutes() === 0) {
          return `${start} ～ ${moment(this.report.lessonEndDate).format('YYYY/MM/DD')}`;
        } else {
          return `${start} ～ ${moment(this.report.lessonEndDate).format('YYYY/MM/DD H:mm')}`;
        }
      }
    }
  }

  get publicTypeName(): string {
    if (!this.report) {
      return '';
    } else {
      return getPublicTypeName(this.report.publicType);
    }
  }

  get updateDate(): string {
    if (!this.report) {
      return '';
    } else {
      return (this as any).$moment(this.report.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get dispReportNote() {
    if (!this.report?.reportNote) {
      return '';
    }
    const reg = new RegExp(/(https?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+))/g);
    const value = this.report.reportNote.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return '<pre>' + value.replace(reg, '</pre><a href="$1" target="_blank">$1</a><pre>') + '</pre>';
  }

  private mounted() {
      this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Report);
  }

  private async loadData() {
    try {
      await this.$store.dispatch('report/selectReport', this.reportId);
    } catch (error) {
      //
    }

    if (!this.report) {
      this.$router.push({
        name: 'ReportList',
      });
    }
  }

  private onChangeSendDateTime(form: any) {
    if (!this.sendDate || !this.sendTime) {
      form.sendDate = null;
    } else {
      form.sendDate = new Date(
        this.sendDate.getFullYear(),
        this.sendDate.getMonth(),
        this.sendDate.getDate(),
        this.sendTime.getHours(),
        this.sendTime.getMinutes(),
      );
    }

    (this.$refs.confirmForm as any).validateField('sendDate');
  }

  private onClickSendDateTimeNow(form: any) {
    const now = new Date();
    this.sendDate = new Date(now.getTime());
    this.sendTime = new Date(now.getTime());

    this.onChangeSendDateTime(form);
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private submitConfirmForm() {
    (this.$refs.confirmForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.reportConfirm as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async confirmReport() {
    let result: {
      sendDate: Date | null,
    };
    try {
      this.sendDate = null;
      this.sendTime = null;
      const form = {
        sendDate: null,
        isPublic: this.report.publicType === PublicTypes.Public,
      };
      result = (await (this.$refs.reportConfirm as DialogWrapper).open({...form}) as any);
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('report/confirmReport', {
        reportId: this.reportId,
        sendDate: result.sendDate,
      });

      this.$router.push({ name: 'ReportList' });

      this.$notify({
        title: '指導報告書承認完了',
        message: '指導報告書を承認しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '指導報告書承認エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private quoteReport() {
    this.$router.push({
      name: 'ReportQuote',
      params: {
        reportId: this.reportId
      }
    });
  }

  private editReport() {
    this.$router.push({
      name: 'ReportEdit',
      params: {
        reportId: this.reportId
      }
    });
  }

  private async deleteReport() {
    try {
      await this.$confirm('指導報告書を削除します。よろしいですか？', '指導報告書削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('report/deleteReport', this.reportId);

      this.$router.push({ name: 'ReportList' });

      this.$notify({
        title: '指導報告書削除完了',
        message: '指導報告書を削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '指導報告書削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }
}
